<template>
  <div class="container info-container">
    <h1>$XBANK</h1>
    <h2>$XBANK – The Fuel Behind the Pixel Wall</h2>
    <p>
      As XRP OGs, we've built something unforgettable — the Million Pixel XRP Wall, where every spot tells a story and every holder becomes part of XRP history.
      And now, we're bringing even more power to the community with <strong>$XBANK</strong> — the token that fuels everything we’re building next.
    </p>

    <h2>Total Supply: 100 Billion $XBANK Tokens</h2>
    <p>
      <strong>Distribution:</strong><br>
      • 90% Airdropped to Pixel Wall spot owners, trustline holders & $XBANK holders (now completed)<br>
      • 10% Allocated for marketing and ecosystem growth<br>
      • Issuer account is blackholed — meaning no more $XBANK can ever be created 🚫🔥
    </p>

    <h2>Why $XBANK Matters</h2>
    <p>
      🔥 <strong>Deflationary by Design</strong><br>
      Revenue from premium wall spots and events goes back into the ecosystem through $XBANK buybacks and burns.
      That means fewer tokens in circulation — and stronger value for the community over time.
      <br><br>
      🖼️ <strong>Powering Pixel Wall 2.0</strong><br>
      $XBANK is your utility token for all future interactions on the Wall. Want to update your image?
      You'll be able to do that directly from your profile using $XBANK — smooth, fast, and recorded on-chain.
      <br><br>
      🤝 <strong>A Community Utility Token</strong><br>
      $XBANK isn’t just a token — it’s the glue connecting legends of the XRPL with future drops, collaborations, events, and campaigns.
    </p>

    <h2>💸 Where to Buy $XBANK</h2>
    <p>
      You can find official links to trusted places to buy $XBANK here:<br>
      👉 <a style="color: white;" href="https://linktr.ee/millionpixelxrp" target="_blank">https://linktr.ee/millionpixelxrp</a><br><br>
      Get in early, build your presence, and ride with the legends of the XRPL.
    </p>
  </div>
</template>

<script>
export default {
  name: 'XbankPage'
}
</script>

<style scoped>
</style>
